const isViewExam = {
  state: {
    isView : false,
  },
  //set方法
  mutations: {
    SET_ISVIEW(state,payload){
      state.isView = payload;
    }
  },
};

export default isViewExam;
